<template>
  <div class="c-corona-banners" v-show="isShown" @click="hide">
    <div class="c-corona-banners-wrapper" v-show="filteredDiscount.length">
      <div class="c-discount c-discount--campaign"
           v-for="discount in filteredDiscount"
           :style="getStyles(discount.bannerSettings)">
        <div class="corona-times" @click="hide">
          <i style="margin-right: 10px;" class="u-fa u-fa-times"></i>
        </div>
        <div class="c-discount__title">
          <span v-show="discount.bannerSettings.icon" :class="`u-mr-1 u-fa u-${discount.bannerSettings.icon}`"></span>
          <span class="c-discount-base" v-text="discount.name"></span>
        </div>
        <div class="c-discount__text" v-html="discount.comment"></div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Discount, DiscountBannerSetting } from '../store/modules/discounts';
import BaseComponent from './Base';

const UiStore = namespace('ui');
    const DiscountsStore = namespace('discounts');

    @Component
    export default class CoronaBanners extends BaseComponent {
        @UiStore.State('covidFormShowed') protected isShown: boolean;
        @UiStore.Mutation('covidShowForm') protected covidShowForm: (state?: boolean) => void;
        @DiscountsStore.State('discounts') protected readonly discounts: Discount[];
        protected panesState: Array<{ id: number, state: boolean, showIt: boolean }> = [];

      protected get filteredDiscount(): Discount[] {
          const discounts: Discount[] = [];
          const discount = this.discounts.find((d) => {
            return d.bannerSettings.enabled && d.name !== null && d.name.length > 0 && d.comment !== null && d.comment.length > 0;
          });
          if (discount) {
            discounts.push(discount);
          }
          // this.panesState.splice(0, this.panesState.length);
          // discounts.forEach((d) => this.panesState.push({ id: d.id, state: false }));

          return discounts;
        }

      protected getStyles(setting: DiscountBannerSetting): { [p: string]: any } {
        return {
          color: setting.fontColor,
          backgroundColor: setting.bgColor,
        };
      }

      protected hide() {
        this.covidShowForm(false);
      }
    }
</script>
